
import React from 'react';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
import classnames from 'classnames';

export default function OrganiserTopNav({activeTab, organiserId, isNew}:any) {
    return (
        <Nav tabs horizontal="true">
            <NavItem >
                <NavLink className={classnames({ active: activeTab === 'Organiser' })} href={'/#/organisers/' + organiserId}>
                    <i className="fas fa-id-card mr-1"></i>Organiser
                </NavLink>
            </NavItem>
            {
                !isNew && (
                <NavItem>
                    <NavLink className={classnames({ active: activeTab === 'Trainers' })} href={'/#/organisers/' + organiserId + '/trainers'}>
                        <i className="fas fa-users mr-1"></i>Trainers
                    </NavLink>
                </NavItem>
                )
            }
        </Nav>
    )
}